import { render, staticRenderFns } from "./usuarios_especialidades_admin.vue?vue&type=template&id=5a62360a&scoped=true&"
import script from "./usuarios_especialidades_admin.vue?vue&type=script&lang=js&"
export * from "./usuarios_especialidades_admin.vue?vue&type=script&lang=js&"
import style0 from "./usuarios_especialidades_admin.vue?vue&type=style&index=0&id=5a62360a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a62360a",
  null
  
)

export default component.exports